import { motion } from 'framer-motion'
import { GlobeAltIcon } from '@heroicons/react/24/outline'

export default function LanguageToggle({ language, onToggle }) {
  return (
    <motion.div 
      className="fixed top-6 right-6 z-50"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5 }}
    >
      <button
        onClick={onToggle}
        className="flex items-center gap-2 bg-white/90 backdrop-blur-sm hover:bg-white px-4 py-2 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 border border-neutral-200"
        aria-label="Toggle language"
      >
        <GlobeAltIcon className="h-5 w-5 text-primary-500" />
        <span className="font-medium text-neutral-800">
          {language === 'ja' ? 'EN' : '日本語'}
        </span>
      </button>
    </motion.div>
  )
}
